var t=Object.prototype.hasOwnProperty;function n(n){var e=n.length,r=new n.constructor(e);return e&&"string"==typeof n[0]&&t.call(n,"index")&&(r.index=n.index,r.input=n.input),r}export{n as default};
//# sourceMappingURL=_initCloneArray.js.map
